export enum ConnectionRequest {
  Medtochka = 'request_connect_medtochka',
  Telemed = 'request_connect_telemed',
}
